// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles__heading___1y8uA","colorIcon":"styles__colorIcon___3TxfF","buttons":"styles__buttons___3lMXd","delete":"styles__delete___1iRRC"};